import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { sanitizeFilename } from '@/utils/FileManager';
import SheetModal from '@/components/General/SheetModal';
import Input from '@/components/General/inputs/Input';
import SheetSelector from '@/components/General/inputs/SheetSelector';

const CreateFolderModal = ({ visible, onClose, onCreate, folder }) => {
  const [name, setName] = useState('');
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (visible) {
      setName(folder?.name || '');
      setSelectedRoles(folder?.Roles || []);
      setError('');
    }
  }, [visible, folder]);

  const isEditing = !!folder;
  const title = isEditing ? 'Edit Folder' : 'New Folder';
  const confirmText = isEditing ? 'Save' : 'Create';

  const handleSubmit = () => {
    if (!name.trim()) {
      setError('Folder name is required');
      return;
    }

    const sanitized = sanitizeFilename(name);
    if (sanitized !== name) {
      setError('Folder name contains invalid characters');
      return;
    }

    onCreate?.({ name, roleIDs: selectedRoles.map(r => r.id) });
  };

  return (
    <SheetModal
      isOpen={visible}
      onCancel={onClose}
      onClose={onClose}
      title={title}
      confirmText={confirmText}
      onConfirm={handleSubmit}
    >
      <View style={{ padding: 20, gap: 20 }}>
        <Input isNotOnSurface title="Folder name" value={name} onUpdate={setName} />

        {error ? (
          <Text style={{ color: 'red', fontSize: 12 }}>{error}</Text>
        ) : null}

        <SheetSelector
          isNotOnSurface
          type="roles"
          title="Roles"
          multiple
          value={selectedRoles}
          onChange={setSelectedRoles}
        />
      </View>
    </SheetModal>
  );
};

export default CreateFolderModal;
